import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Emoji from "../Emoji";
import Icon from "../Icon";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var Status = function Status(props) {
  var children = props.children,
    emoji = props.emoji,
    text = props.text,
    className = props.className;
  var success = className && className.indexOf('success') > -1;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper', {
      success: success
    }, className),
    "data-t-id": "components-Status"
  }, emoji && /*#__PURE__*/React.createElement("div", {
    className: cx('emoji')
  }, /*#__PURE__*/React.createElement(Emoji, {
    className: cx('emojiImage'),
    name: emoji
  })), success && /*#__PURE__*/React.createElement(Icon, {
    className: cx('icon'),
    name: "checked",
    scale: 1.2
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('content')
  }, children, text && /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: text
    }
  })));
};
Status.propTypes = process.env.NODE_ENV !== "production" ? {
  emoji: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  text: PropTypes.string
} : {};
export default Status;